import { Box } from "@mui/material";
import { TVChartContainer } from '../../components/TVChartContainer/atr_daily';
import './daily.css'

const AtrDaily = () => {
  return (
    <Box className='daily' m="20px" height="60%">
      <div>
        <TVChartContainer />
      </div>
    </Box>
  );
};

export default AtrDaily;